import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { authService } from "@/services/authService";
import { safeStorage } from "@/services/safeStorage";
import { LANGUAGES, translations } from "@/i18n/translations";

const LanguageContext = createContext(null);
const KEY = "pt_lang";

export const LanguageProvider = ({ children }) => {
  const { user } = useAuth();
  const [language, setLanguage] = useState(() => safeStorage.get(KEY) || "pt");

  useEffect(() => {
    if (user && user.language && user.language !== language) setLanguage(user.language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, user?.language]);

  useEffect(() => {
    safeStorage.set(KEY, language);
    document.documentElement.setAttribute("lang", language);
  }, [language]);

  const change = useCallback(
    (code) => {
      if (!translations[code]) return;
      setLanguage(code);
      authService.setLanguage(code).catch(() => {});
    },
    []
  );

  const t = useCallback(
    (key) => translations[language]?.[key] ?? translations.pt[key] ?? key,
    [language]
  );

  const value = useMemo(
    () => ({ language, change, t, languages: LANGUAGES }),
    [language, change, t],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext) || { language: "pt", t: (k) => translations.pt[k] ?? k, change: () => {}, languages: LANGUAGES };
